import * as React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome"
import { Pressable, PressableProps, StyleProp, StyleSheet, TextStyle } from "react-native"
import { RadioButtonPresets, styles, viewPresets } from "./RadioButton.presets"
import { Text } from "../Text/Text"
import { palette } from "../../theme"

export interface Props extends PressableProps {
  style?: any
  textStyle?: StyleProp<TextStyle>
  preset?: RadioButtonPresets
  label?: string
  checked?: boolean
  onChange: (label: string, value: boolean) => void
}

const icons = {
  circle: {
    iconDone: ["fas", "check-circle"],
    iconNotDone: ["far", "circle"],
  },
  square: {
    iconDone: ["fas", "check-square"],
    iconNotDone: ["far", "square"],
  },
}

export function RadioButton(props: Props): JSX.Element {
  const {
    preset = "square",
    label = "",
    checked,
    style: styleOverride,
    textStyle,
    onChange,
    ...rest
  } = props

  const style = viewPresets[preset]
  const viewStyle = StyleSheet.flatten([styles.main, styleOverride])
  const textStyles = StyleSheet.flatten([styles.radioButtonLabel, textStyle])

  const handlePress = () => {
    onChange(label, !checked)
  }

  return (
    <Pressable onPress={handlePress} style={viewStyle} {...rest}>
      <FontAwesomeIcon
        style={styles.iconStyle}
        size={style.size}
        icon={checked ? icons[preset].iconDone : icons[preset].iconNotDone}
        color={checked ? style.color : palette.dim}
      />

      <Text style={textStyles}>{label}</Text>
    </Pressable>
  )
}
